<template>
    <div>


 

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item"  >
                    <b-field label="No." >
                        <p class="control">
                            <span class="button is-static is-medium "  >{{index}}.</span>
                        </p>
                    </b-field>
                </div>
                
                <div class="level-item" >

                    <b-field label="Bacterial name" style="width: 100%">
                        <b-select placeholder="Select a name Bacterial"   size="is-medium" v-model="data_bact.idbact">
                            <option
                                    v-for="bactDat in mstBactDat"
                                    :value="bactDat.id"
                                    :key="bactDat.id">
                                {{ bactDat.name }}
                            </option>
                        </b-select>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"  @click="clearContent('','idbact')"></b-button>
                        </p>
                        <p class="control">
                            <b-button type="is-success" size="is-medium" outlined icon-right="magnify"    @click="selectBact"></b-button>
                        </p>
                    </b-field>
                </div>

<!--                <div class="level-item" >-->
<!--                    <b-field label="Add Bacterial">-->
<!--                        <b-button type="is-success" size="is-medium" outlined icon-right="plus"  @click="selectBact"></b-button>-->
<!--                    </b-field>-->
<!--                </div>-->

                <div class="level-item"  style="width: 100%"  >
                    <b-field   label="Remark" style="width: 100%">
                        <template slot="label">
                            Remark <span :class=" [ data_bact.bact_remark && data_bact.bact_remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                        v-if="data_bact.bact_remark && data_bact.bact_remark.length>0">
                                                     ({{data_bact.bact_remark.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_REMARK}})
                                              </span>
                        </template>
                        <b-input v-model="data_bact.bact_remark" style="width: 100%"   size="is-medium"></b-input>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"  @click="clearContent('','bact_remark')"></b-button>
                        </p>
                    </b-field>
                </div>




            </div>
            <div class="level-right">

                <div class="level-item">
                    <b-button type="is-danger is-light"
                              icon-right="close"
                              @click="deleteEachBactID"
                              :disabled="!enable"
                    />
                </div>
            </div>
        </nav>

        <hr>

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p style="padding-left: 3.8em "></p>
                </div>
                <div class="level-item">
                    <b-field label="Method" style="width: 100%">
                        <b-select placeholder="Select a Method"   size="is-medium" v-model="data_bact.id_lab_method">
                            <option
                                    v-for="method in mstMethod"
                                    :value="method.id"
                                    :key="method.id">
                                {{ method.name }}
                            </option>
                        </b-select>

                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearMethod"></b-button>
                        </p>
                        <p class="control">
                            <b-button type="is-success" size="is-medium" outlined icon-right="magnify"    @click="selectMethod"></b-button>
                        </p>
                    </b-field>


                </div>


                <div class="level-item" v-if="data_bact.id_lab_method">
 
                    <b-field label="Value" style="width: 100%">
                        <b-select placeholder="Select Value "   size="is-medium" v-model="data_bact.id_lab_method_result">
                            <option
                                    v-for="result in filterOfResultMethodLab(data_bact.id_lab_method)"
                                    :value="result.id"
                                    :key="result.id">
                                {{ result.data }}
                            </option>
                        </b-select>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearMethodResult"></b-button>
                        </p>
                    </b-field>
                </div>


                <div class="level-item" v-if="data_bact.id_lab_method_result">

                    <b-field   label="Remark"  style="width: 100%">
                        <template slot="label">
                            Remark <span :class=" [ data_bact.remark_method && data_bact.remark_method.length>GLOBAL_VAR.MAX_CHAR_BACT_METHOD ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                         v-if="data_bact.remark_method && data_bact.remark_method.length>0">
                                                     ({{data_bact.remark_method.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_METHOD}})
                                              </span>
                        </template>
                        <b-input v-model="data_bact.remark_method" style="width: 100%"   size="is-medium" ></b-input>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearRemarkMethod"></b-button>
                        </p>
                    </b-field>
                </div>



            </div>

        </nav>


        <hr>
<!--        {{data_bact}}-->
<!--        draggable-->
<!--        @dragstart="dragstart"-->
<!--        @drop="drop"-->
<!--        @dragover="dragover"-->
<!--        @dragleave="dragleave"-->
        <b-checkbox v-model="data_bact.want_data_drugs" @input="loadEmplyDrugFromTemplateIntoObj">
           <p class="has-text-grey">{{ cbTxtIncludeOrExcludeDrug }}</p>
        </b-checkbox>
        <b-table
                v-if="data_bact.want_data_drugs"
                :data="data_bact.drugs"
                :bordered=false
                :striped=false
                narrowed



                :hoverable=false
                :focusable=false
                mobile-cards>

            <b-table-column   label="No"  v-slot="props"  >

                {{props.index +1 }}.

            </b-table-column>

            <b-table-column   label="Drug"   >
                <template  v-slot:header="{ column }">

<!--                    <b-field-->
<!--                            custom-class="is-medium"-->
<!--                            horizontal>-->
<!--                        <template #label>-->
                               {{column.label}}
<!--                        </template>-->
                        <b-button size="is-small"
                                  type="is-success is-light"

                                  @click="addDrugInEachIDbact_uuid"
                                  icon-left="plus">
                            Add
                        </b-button>
<!--                    </b-field>-->
                </template>
                <template v-slot="props">
                    <h3 class="subtitle is-5"> {{ props.row.drug_name }}</h3>
                </template>


            </b-table-column>

            <b-table-column   label="MIC"    v-slot="props">

                <b-field>
                    <p class="control">
                        <b-select    v-model="props.row.idmic_prefix" >
                            <option
                                    v-for="micDat in mstMicDat"
                                    :value="micDat.id"
                                    :key="micDat.id">
                                {{ micDat.name }}
                            </option>
                        </b-select>
                    </p>
                    <b-input v-model="props.row.mic_val" ></b-input>
                    <p class="control">
                        <b-button type="is-danger" outlined icon-right="close"  @click="clearContent(props.row.iddrug,'mic')"></b-button>
                    </p>
                </b-field>
            </b-table-column>


            <b-table-column   label="Result"    >
                <template v-slot:header="{ column }">
                    {{ column.label }}
                    <span class="has-text-danger">*</span>


                    <b-dropdown aria-role="list"     >
                        <template #trigger>
                            <p
                                    class="tag is-success is-light"
                                    role="button">
                                All
                            </p>
                        </template>


                        <b-dropdown-item value="1" @click="setAllResult('1')" aria-role="listitem">R</b-dropdown-item>
                        <b-dropdown-item value="2" @click="setAllResult('2')" aria-role="listitem">I</b-dropdown-item>
                        <b-dropdown-item value="3" @click="setAllResult('3')"  aria-role="listitem">S</b-dropdown-item>
                        <b-dropdown-item value=null @click="setAllResult(null)" aria-role="listitem">clear all</b-dropdown-item>

                    </b-dropdown>


                </template>
                <template v-slot="props">
                    <b-field >
                    <p class="control">
                    <b-select placeholder="R/I/S"  v-model="props.row.idresult" >
                        <option
                                v-for="resultDat in mstResultDat"
                                :value="resultDat.id"
                                :key="resultDat.id">
                            {{ resultDat.name }}
                        </option>
                    </b-select>
                    </p>
                    <p class="control">
                        <b-button type="is-danger  is-light"  icon-right="close"   @click="clearContent(props.row.iddrug,'result')" ></b-button>
                    </p>
                    </b-field>
                </template>


            </b-table-column>


            <b-table-column   label="Remark"   v-slot="props" >

                <b-field  :type="{ 'is-danger':   props.row.remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH  }"
                          :message= "{ 'Max Over range' :   props.row.remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH   }"  expanded>
                    <b-input v-model="props.row.remark"

                    >{{ props.row.remark }} </b-input>
                    <template slot="message">
                        <span class="has-text-primary is-italic" v-if="props.row.remark">({{props.row.remark.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH}})</span>
                    </template>
                </b-field>

            </b-table-column>

            <b-table-column   label="#"   v-slot="props" >
                <b-button type="is-danger"
                          icon-left="delete"

                          @click="deleteDrugItem( props.row.iddrug_uuid)"
                          :disabled="!enable"
                          >
                    Delete
                </b-button>
            </b-table-column>

<!--            <b-table-column   label="#"   v-slot="props" >-->
<!--                {{ props.row.sort_id }}-->
<!--            </b-table-column>-->


<!--            <b-table-column   label="#"   v-slot="props" >-->
<!--                {{ props.row.iddrug_uuid }}-->
<!--            </b-table-column>-->

        </b-table>
        <SelectDrug
            v-if="isShowSelectDrug"
            :isShowing = isShowSelectDrug
            :drugExisting = data_bact.drugs
            @closeSelectDrug = "closeSelectDrug"
            @closeSelectDrugWithData = "closeSelectDrugWithData"
        />


        <SelectBact
                v-if="isShowSelectBact"
                :isShowing = isShowSelectBact
                @closeSelectBact = "closeSelectBact"
                @closeSelectBactWithPickData = "closeSelectBactWithPickData"

        />


        <SelectMethod
                v-if="isShowSelectMethod"
                :isShowing = isShowSelectMethod
                @closeSelectMethod = "closeSelectMethod"
                @closeSelectMethodWithPickData = "closeSelectMethodWithPickData"

        />



    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {  MAX_CHAR_BACT_REMARK_EACH , MAX_CHAR_BACT_REMARK , MAX_CHAR_BACT_METHOD , genUUID}  from '@/utils.js'
    import SelectDrug from "./SelectDrug";
    import SelectBact from "./SelectBact";
    import SelectMethod from "./SelectMethod";

    export default {
        name: "Each_Bact",
        components:{
            SelectDrug,
            SelectBact,
            SelectMethod
        },
        mounted() {
            // this.bacterialModel = this.data_bact.idbact
        },
        props:{
            enable : Boolean,
            index : Number,
            data_bact : Object  //     example data
                                //        {
                                //         "idbact_uuid": "763eee4bdabe",
                                //         "idbact": 1,
                                //         "name_bact": "Beta staphylococcus intermedius group3+",
                                //         "bact_remark" : "",
                                //         "drugs": [
                                //         {
                                //             "iddrug": 2,
                                //             "drug_name": "Azithromycin",
                                //             "idresult": 1,
                                //             "result_name": "R",
                                //             "idmic_prefix": 1,
                                //             "mic_prefix": ">=",
                                //             "mic_val": "64",
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 1,
                                //             "drug_name": "Cephalexin",
                                //             "idresult": 1,
                                //             "result_name": "R",
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 4,
                                //             "drug_name": "Enrofloxacin",
                                //             "idresult": null,
                                //             "result_name": null,
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 3,
                                //             "drug_name": "Marbofloxacin",
                                //             "idresult": 3,
                                //             "result_name": "S",
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         }
                                //     ]
                                // }
        },
        computed: {
            ...mapState({
                mstMicDat: state => state.bact.mstMicDat,
                mstBactDat: state => state.bact.mstBactDat,
                mstResultDat: state => state.bact.mstResultDat,

                mstMethod: state => state.bact.mstMethod,
                mstMethodResult : state => state.bact.mstMethodResult,

                dataBACTSpecLN : state => state.bact.dataBACTSpecLN,
                tmplateBact : state => state.bact.tmplateBact,
            }),
            GLOBAL_VAR(){
                return { MAX_CHAR_BACT_REMARK_EACH , MAX_CHAR_BACT_REMARK , MAX_CHAR_BACT_METHOD }
            },

            cbTxtIncludeOrExcludeDrug : function(){
                return this.data_bact.want_data_drugs ? "Include Drugs" : "Exclude Drugs"
            }
        },
        methods:{  /* eslint-disable */
            // dragstart (payload) {
            //     this.draggingRow = payload.row
            //     this.draggingRowIndex = payload.index
            //     payload.event.dataTransfer.effectAllowed = 'copy'
            // },
            // dragover(payload) {
            //     payload.event.dataTransfer.dropEffect = 'copy'
            //     payload.event.target.closest('tr').classList.add('is-selected')
            //     payload.event.preventDefault()
            // },
            // dragleave(payload) {
            //     payload.event.target.closest('tr').classList.remove('is-selected')
            //     payload.event.preventDefault()
            // },
            // drop(payload) {
            //     payload.event.target.closest('tr').classList.remove('is-selected')
            //     const droppedOnRowIndex = payload.index
            //     this.$buefy.toast.open({
            //         message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
            //         duration:500
            //     })
            //
            //     this.swapArrayElements(this.data_bact.drugs , this.draggingRowIndex ,droppedOnRowIndex )
            //     this.data_bact.drugs[droppedOnRowIndex]['uuid'] = genUUID(6)
            //     this.data_bact.drugs[this.draggingRowIndex]['uuid'] = genUUID(6)
            // },
            // swapArrayElements (arr, indexA, indexB) {
            //     // var temp = arr[indexA];
            //     // arr[indexA] = arr[indexB];
            //     // arr[indexB] = temp;
            //     var temp = arr[indexA];
            //     arr.splice(indexA,1)
            //     arr.splice(indexB,0,temp)
            //     this.reMakeIndexSort(arr)
            // },
            // reMakeIndexSort(arr){
            //     for(var i = 0;i<arr.length;i++){
            //             arr[i]['sort_id'] = i
            //     }
            // },

            loadEmplyDrugFromTemplateIntoObj(){
                if (this.data_bact.drugs.length === 0){
                    this.data_bact.drugs =  JSON.parse(JSON.stringify(this.tmplateBact.drugs))
                }
            },

            setAllResult(_dat){

                this.data_bact.drugs.forEach(dat=>{
                        dat.idresult = _dat
                })


            },
            clearMethod(){
                this.data_bact.id_lab_method  = ""
            }  ,
            clearMethodResult(){
                this.data_bact.id_lab_method_result = ""
            }   ,
            clearRemarkMethod(){
                this.data_bact.remark_method = ""
            }    ,
            filterOfResultMethodLab(idMethod) {
                const tmp =  this.mstMethodResult.find(dat=>{
                    return dat.id_methodlab === idMethod
                })


                if (tmp){
                    // console.log(JSON.stringify(tmp))
                    return tmp.data
                } else{
                    return  {
                        "id_methodlab": "",
                        "data": []
                    }
                }




            },


            closeSelectBactWithPickData(payload){
                // console.log(JSON.stringify(payload))
                this.data_bact.idbact = payload.id
                this.isShowSelectBact = false
            },

            closeSelectBact(){
                this.isShowSelectBact = false
            },


            closeSelectMethodWithPickData(payload){
                this.data_bact.id_lab_method = payload.id
                this.isShowSelectMethod = false
            },

            closeSelectMethod(){
                this.isShowSelectMethod = false
            },


            selectBact(){
                this.isShowSelectBact = true
            },
            selectMethod(){
                this.isShowSelectMethod = true
            },






            closeSelectDrugWithData(payload){
                payload.forEach(dat=>{

                    this.data_bact.drugs.push(
                                                {
                                                "iddrug": dat.id,
                                                "drug_name": dat.name,
                                                "idresult": null,
                                                "result_name": null,
                                                "idmic_prefix": null,
                                                "mic_prefix": null,
                                                "mic_val": null,
                                                "remark": "",
                                                "sort_id": "",
                                                "iddrug_uuid":   genUUID(12)
                                                }
                                             )
                })

                this.isShowSelectDrug = false
            },
            closeSelectDrug(){
                this.isShowSelectDrug = false
            },
            addDrugInEachIDbact_uuid(){
                this.isShowSelectDrug = true


            },
            deleteEachBactID(){
                // console.log(this.data_bact.idbact_uuid)
                this.$emit('delete_idbact_uuid',this.data_bact.idbact_uuid)
            },
            deleteDrugItem(iddrug_uuid){
                const tmpDrug = this.data_bact.drugs.find(dat=>{
                    return dat.iddrug_uuid == iddrug_uuid
                })

                     const tmpDrugName = tmpDrug.drug_name
                     const memberIndex =  this.data_bact.drugs.indexOf(tmpDrug)
                     this.data_bact.drugs.splice(memberIndex,1)

                     this.$buefy.toast.open({
                        duration: 1500,
                        message: `Item drug  <i class="is-size-3 has-text-weight-bold "> ${tmpDrugName} </i>   has been <b>delete</b>`,
                        position: 'is-bottom',
                        type: 'is-primary'
                     })
                    //  this.$buefy.dialog.confirm({
                    //     title: 'Deleting Drug?',
                    //     message: 'Are you sure you want to <b>delete</b> drug? This action cannot be undone.',
                    //     confirmText: 'Delete Drug',
                    //     type: 'is-danger',
                    //     hasIcon: true,
                    //     onConfirm: () =>  this.data_bact.drugs.splice(memberIndex,1)
                    // })


            },
            clearContent(iddrug,kind){



                if(kind === 'idbact'){
                    this.data_bact.idbact  = null
                    return
                }


                if(kind === 'bact_remark'){
                    this.data_bact.bact_remark  = ''
                    return
                }

                // find drug
                const tmpDrug = this.data_bact.drugs.find(dat=>{
                    return dat.iddrug == iddrug
                })
                // console.log(tmpDrug)

                if(tmpDrug){
                    // kind === 'mic'  or  'result'
                    if(kind === 'result'){

                        tmpDrug.idresult = null
                        tmpDrug.result_name = null
                    }
                    if(kind === 'mic'){
                        tmpDrug.idmic_prefix = null
                        tmpDrug.mic_prefix = null
                        tmpDrug.mic_val = null
                    }

                }
            },



        },
        data(){
            return {
                // bacterialModel : null,
                isShowSelectDrug : false,
                draggingRow: null,
                draggingRowIndex: null ,


                //
                isShowSelectBact : false,
                isShowSelectMethod : false,


                //
                // methodLab : [ {"id":1 , "descp" :"ตรวจหาเชื้อแบคทีเรียทั่วไป"},
                //               {"id":2 , "descp" :"ตรวจหาเชื้อแบคทีเรียด้วยกล้องจุลทรรศน์ Gram stain"},
                //               {"id":3 , "descp" :"ตรวจหาเชื้อแบคทีเรียด้วยกล้องจุลทรรศน์ Dark field (spirochete)"},
                //              ] ,
                //
                // resultOfMethodLab : [{"id":1 , "id_methodlab": 1 , "data": ["+1","+2","+3"]} ,
                //     {"id":2 , "id_methodlab": 2 , "data": ["Gram +","Gram -"]} ,
                //     {"id":2 , "id_methodlab": 3 , "data": ["Neg","Pos"]}
                // ],



                // methodLabSelected : null,
                // resultOfMethodLabSelected : null,
                // remark_methodLab : null,



                // allResultSelected : null,





            }
        },
        watch:{

           "data_bact.id_lab_method" : {
               immediate : true,
               handler: function () {
                       this.data_bact.id_lab_method_result = ""
                       this.data_bact.remark_method = ""
                       // console.log('clear data_bact.id_lab_method_result')

                   // if(val === "" || val === null){
                   //     // clear
                   //     this.data_bact.id_lab_method_result = ""
                   //     this.data_bact.remark_method = ""
                   //     console.log('clear data_bact.id_lab_method_result')
                   // }
               }
           },
            // allResultSelected:{
            //    immediate: true,
            //     handler : function (val) {
            //        // console.log(val)
            //
            //             this.data_bact.drugs.forEach(dat=>{
            //                 console.log('doooo ')
            //                 if(val == "1" || val == "2" ||val == "3"){
            //                     dat.idresult = val
            //                 }else{
            //                     dat.idresult = null
            //                 }
            //
            //             })
            //
            //
            //     }
            // }
        }
    }
</script>

<style scoped>
    /*.button-clear:hover{*/
    /*    opacity: 100%; !important;*/
    /*}*/
    /*.button-clear{*/
    /*    opacity: 0%; !important; */
    /*}*/
</style>